import { useAppScopeStore } from '@frontend/scope';

export const useMultiLocationUtils = () => {
  const { accessibleLocationData } = useAppScopeStore();

  const getLocationData = (locationId: string | undefined) =>
    locationId ? accessibleLocationData?.[locationId] : undefined;

  const getLocationName = (locationId?: string) => getLocationData(locationId)?.name;

  const getLocationOpsType = (locationId?: string) => getLocationData(locationId)?.opsType;

  return {
    getLocationName,
    getLocationOpsType,
  };
};
